const config = {
  API_URL: import.meta.env.VITE_API_URL || 'https://platform.intertechnologies.ru',
  WS_URL: import.meta.env.VITE_WS_API_URL || 'wss://platform.intertechnologies.ru',
  YANDEX_SUGGEST_KEY: '9e30a353-ae18-45de-ba3e-e8802e1065d5',
  YANDEX_GEOCODE_KEY: 'f18dd43f-38f8-4fd3-9c8e-da8ff4bda36f',
}

export default config
